import React from 'react';
import cn from 'classnames';
import Bullets from 'slickpay/common/Bullets.component';
import ImageCard from 'slickpay/common/ImageCard.component';

import IMG_TABLE from 'assets/slickpay-splash/payment/payment-table.png';
import IMG_GIF from 'assets/slickpay-splash/tip/tiping-animation-sm.gif'; //
import Badge from 'components/generic/Badge.component';
import Video from 'components/generic/Video.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import C from 'utils/values/constant.util';

import CN from './ImageCardGroup.module.scss';

const VIDEO_LINK = 'https://www.youtube.com/embed/1AdJkjLJwKs?si=9XGfUQUpOBjdgaOb';

const ImageCardGroup = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const DATA_TIPS = C([
    t('slickPay.noReader.slickTipsBullet1'),
    t('slickPay.noReader.slickTipsBullet2'),
    t('slickPay.noReader.slickTipsBullet3'),
    t('slickPay.noReader.slickTipsBullet4'),
  ]);

  const DATA_DIARY = [
    t('slickPay.noReader.whySlickBullet1'),
    t('slickPay.noReader.whySlickBullet2'),
    <>
      {t('slickPay.noReader.whySlickBullet3Part1')} <CurrencySign /> {t('slickPay.noReader.whySlickBullet3Part2')}
    </>,
  ];

  const DATA_CARD = C([
    t('slickPay.noReader.feesBullet1'),
    t('slickPay.noReader.feesBullet2'),
    t('slickPay.noReader.feesBullet3'),
  ]);

  return (
    <div
      data-bem="ImageCardGroup"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <ImageCard variantReverse data-bem="NoReaderLayout__imageCard">
        <div className={CN.cardImage}>
          <div className={CN.frontContainer}>
            <img src={IMG_GIF} alt="" className={CN.imgCard} />
          </div>
        </div>
        <div className={CN.cardText}>
          <div className={CN.inline}>
            <Badge name={t('slickPay.noReader.slickTipsBadge')} variant="fine" />
          </div>

          <div className={CN.cardTitle}>
            {t('slickPay.noReader.slickTipsTitlePart1')}
            <span className={CN.textBreak}>{t('slickPay.noReader.slickTipsTitlePart2')}</span>
          </div>
          <Bullets data={DATA_TIPS} />
        </div>
      </ImageCard>

      <ImageCard data-bem="NoReaderLayout__imageCard">
        <div className={CN.video}>
          <div className={CN.cardVideo}>
            <Video src={VIDEO_LINK} title={t('slickPay.noReader.videoTitle')} variant="full" />
          </div>
          <div className={CN.videoBadge}>
            <Badge variant="outline">
              <div className={CN.videoBadgeText}>{t('slickPay.noReader.videoBadge')}</div>
            </Badge>
          </div>
        </div>

        <div className={CN.cardTextRight}>
          <div className={CN.inline}>
            <Badge name={t('slickPay.noReader.whySlickBadge')} variant="fine" />
          </div>
          <div className={CN.cardTitle}>{t('slickPay.noReader.whySlickTitle')}</div>
          <Bullets data={DATA_DIARY} />
        </div>
      </ImageCard>

      <ImageCard variantReverse data-bem="NoReaderLayout__imageCard">
        <div className={CN.cardImage}>
          <div className={CN.frontContainer}>
            <img src={IMG_TABLE} alt="" className={CN.imgCard} />
          </div>
        </div>
        <div className={CN.cardText}>
          <div className={CN.inline}>
            <Badge name={t('slickPay.noReader.feesBadge')} variant="fine" />
          </div>

          <div className={CN.cardTitle}>{t('slickPay.noReader.feesTitle')}</div>
          <Bullets data={DATA_CARD} />
        </div>
      </ImageCard>
    </div>
  );
};

export default ImageCardGroup;
